import LogoHeader from '../../assets/img/logo-header.svg';
import Quality from '../../assets/img/scuore_quality.png';
/**
 * Logo component with support for different variants
 * @param {string} height - Height of the logo (default: '26px')
 * @param {string} variant - Logo variant: 'default', 'header', 'artic', 'quality', 'quality-text'
 */
const Logo = ({ height = '26px', variant = 'default' }) => {
  // Variante especial para Quality con ícono y texto

  const getLogoSrc = () => {
    switch (variant) {
      case 'quality':
        return Quality; // Usar Artic logo para Quality por ahora
      case 'default':
      default:
        return LogoHeader;
    }
  };

  const getAltText = () => {
    switch (variant) {
      case 'header':
        return 'Logo Header';
      case 'artic':
        return 'Artic Logo';
      case 'quality':
        return 'Quality Logo';
      case 'default':
      default:
        return 'Logo';
    }
  };

  return (
    <img
      style={{ maxWidth: '100%' }}
      height={height}
      src={getLogoSrc()}
      alt={getAltText()}
    />
  );
};

export default Logo;
